import { GxIcon, GxPhoneInput } from '@garpix/garpix-web-components-react'
import { attentionIcon } from '@/images'
import classNames from 'classnames'
import style from './styles/input_phone.module.scss'
import React from 'react'
import ErrorText from '../ErrorText'

interface InputPhoneProps {
  theme: string
  className?: string
  label: string
  children?: any
  error?: boolean
  errorText?: string
}

const InputPhone = ({
  children = '',
  className = '',
  label,
  theme = 'gray',
  error = '',
  ...props
}): React.ReactElement<InputPhoneProps> => {
  return (
    <GxPhoneInput
      label={label}
      country='ru'
      disableDropdown
      className={classNames({
        [style.default]: true,
        [style[`theme_${theme}`]]: theme,
        [className]: Boolean(className)
      })}
      {...props}
    >
      {error !== ''
        ? (
          <>
            <GxIcon
              src={attentionIcon}
              slot='suffix'
              className={style.icon_error}
            />
            <ErrorText text={error} />
          </>
          )
        : undefined}
    </GxPhoneInput>
  )
}

export default InputPhone
